(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blocks"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const productCards = document.querySelectorAll('.product-card[data-bg-color][data-border-color]');
    productCards.forEach(card => {
      const bgColor = card.getAttribute('data-bg-color');
      const borderColor = card.getAttribute('data-border-color');
      card.style.setProperty('--bg-color', bgColor);
      card.style.setProperty('--border-color', borderColor);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('.featured-cards-container');
    const wrapper = document.querySelector('.featured-cards-wrapper');
    
    if (!container || !wrapper) return;
    
    let isDown = false;
    let startX;
    let currentTranslate = 0;
    let prevTranslate = 0;
    
    function getPositionX(event) {
      return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    }
    
    function dragStart(e) {
      isDown = true;
      if (e.type === 'mousedown') {
        container.style.cursor = 'grabbing';
      }
      startX = getPositionX(e);
      prevTranslate = currentTranslate;
    }
    
    function dragEnd() {
      isDown = false;
      container.style.cursor = 'grab';
    }
    
    function dragMove(e) {
      if (!isDown) return;
      e.preventDefault();
      
      const currentPosition = getPositionX(e);
      const diff = currentPosition - startX;
      currentTranslate = prevTranslate + diff;
      
      const maxScroll = -(wrapper.scrollWidth - container.offsetWidth);
      
      // Constrain the scroll
      if (currentTranslate > 0) {
        currentTranslate = 0;
      } else if (currentTranslate < maxScroll) {
        currentTranslate = maxScroll;
      }
      
      wrapper.style.transform = `translateX(${currentTranslate}px)`;
    }
    
    // Mouse events
    container.addEventListener('mousedown', dragStart);
    container.addEventListener('mouseleave', dragEnd);
    container.addEventListener('mouseup', dragEnd);
    container.addEventListener('mousemove', dragMove);
    
    // Touch events
    container.addEventListener('touchstart', dragStart);
    container.addEventListener('touchend', dragEnd);
    container.addEventListener('touchmove', dragMove);
    
    container.style.cursor = 'grab';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-faq-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const ROOT_SEL = '[data-pb-faq-accordion-root]';

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function initSection(root) {
      if (!root || root.dataset.pbFaqInit === '1') return;
      root.dataset.pbFaqInit = '1';
      root.classList.add('pb-faq-accordion--enhanced');

      const detailsList = root.querySelectorAll('details[data-pb-faq-details]');

      /* If multiple rows have `open` (e.g. bad save / editor glitch), keep only the first */
      const withOpen = Array.prototype.filter.call(detailsList, function (d) {
        return d.hasAttribute('open');
      });
      if (withOpen.length > 1) {
        withOpen.slice(1).forEach(function (d) {
          d.removeAttribute('open');
        });
      }

      detailsList.forEach((details) => {
        const summary = details.querySelector('summary');
        const panel = details.querySelector('[data-pb-faq-panel]');
        const inner = details.querySelector('[data-pb-faq-panel-inner]');
        if (!summary || !panel || !inner) return;

        if (prefersReducedMotion()) {
          if (details.open) {
            panel.style.maxHeight = 'none';
          } else {
            panel.style.maxHeight = '0px';
          }
          summary.addEventListener('click', function (e) {
            e.preventDefault();
            details.open = !details.open;
            panel.style.maxHeight = details.open ? 'none' : '0px';
          });
          return;
        }

        function setClosedVisual() {
          panel.style.maxHeight = '0px';
        }

        function setOpenFull() {
          panel.style.maxHeight = 'none';
        }

        if (details.open) {
          setOpenFull();
        } else {
          setClosedVisual();
        }

        summary.addEventListener('click', function (e) {
          e.preventDefault();
          const opening = !details.open;

          if (opening) {
            details.open = true;
            panel.style.maxHeight = '0px';
            requestAnimationFrame(function () {
              void inner.offsetHeight;
              const target = inner.scrollHeight;
              requestAnimationFrame(function () {
                panel.style.maxHeight = target + 'px';
              });
            });

            panel.addEventListener(
              'transitionend',
              function onOpenEnd(ev) {
                if (ev.propertyName !== 'max-height') return;
                if (details.open) setOpenFull();
              },
              { once: true }
            );
          } else {
            const h = inner.scrollHeight;
            panel.style.maxHeight = h + 'px';
            void panel.offsetHeight;
            requestAnimationFrame(function () {
              panel.style.maxHeight = '0px';
            });

            panel.addEventListener(
              'transitionend',
              function onCloseEnd(ev) {
                if (ev.propertyName !== 'max-height') return;
                details.open = false;
                panel.style.maxHeight = '0px';
              },
              { once: true }
            );
          }
        });
      });
    }

    function scan(doc) {
      doc.querySelectorAll(ROOT_SEL).forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scan(document);
      });
    } else {
      scan(document);
    }

    document.addEventListener('shopify:section:load', function (ev) {
      if (ev.target && ev.target.querySelector) {
        scan(ev.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-lp-june-survey"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-pb-lp-june-survey]');
    if (!section) return;

    section.addEventListener('click', (event) => {
      const link = event.target.closest('a.pb-lp-june-survey__cta[href^="#"]');
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href || href === '#') return;

      const targetId = decodeURIComponent(href.slice(1));
      const target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();
      const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });

      if (history.pushState) {
        history.pushState(null, '', href);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-lp-product-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__pbLpBuyboxScrollBound) return;
    window.__pbLpBuyboxScrollBound = true;

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href="#pb-lp-buybox"]');
      if (!link) return;

      const buybox = document.getElementById('pb-lp-buybox');
      if (!buybox) return;

      event.preventDefault();

      const heading = document.getElementById('pb-lp-buybox-heading')
        || buybox.querySelector('.pb-lp-product-buybox__title');
      const target = heading || buybox;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      target.scrollIntoView({
        behavior: reduced ? 'auto' : 'smooth',
        block: 'start',
      });

      if (history.pushState) {
        history.pushState(null, '', '#pb-lp-buybox');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-pdp-faq-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const ROOT_SEL = '[data-pb-faq-accordion-root]';

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function initSection(root) {
      if (!root || root.dataset.pbFaqInit === '1') return;
      root.dataset.pbFaqInit = '1';
      root.classList.add('pb-faq-accordion--enhanced');

      const detailsList = root.querySelectorAll('details[data-pb-faq-details]');

      /* If multiple rows have `open` (e.g. bad save / editor glitch), keep only the first */
      const withOpen = Array.prototype.filter.call(detailsList, function (d) {
        return d.hasAttribute('open');
      });
      if (withOpen.length > 1) {
        withOpen.slice(1).forEach(function (d) {
          d.removeAttribute('open');
        });
      }

      detailsList.forEach((details) => {
        const summary = details.querySelector('summary');
        const panel = details.querySelector('[data-pb-faq-panel]');
        const inner = details.querySelector('[data-pb-faq-panel-inner]');
        if (!summary || !panel || !inner) return;

        if (prefersReducedMotion()) {
          if (details.open) {
            panel.style.maxHeight = 'none';
          } else {
            panel.style.maxHeight = '0px';
          }
          summary.addEventListener('click', function (e) {
            e.preventDefault();
            details.open = !details.open;
            panel.style.maxHeight = details.open ? 'none' : '0px';
          });
          return;
        }

        function setClosedVisual() {
          panel.style.maxHeight = '0px';
        }

        function setOpenFull() {
          panel.style.maxHeight = 'none';
        }

        if (details.open) {
          setOpenFull();
        } else {
          setClosedVisual();
        }

        summary.addEventListener('click', function (e) {
          e.preventDefault();
          const opening = !details.open;

          if (opening) {
            details.open = true;
            panel.style.maxHeight = '0px';
            requestAnimationFrame(function () {
              void inner.offsetHeight;
              const target = inner.scrollHeight;
              requestAnimationFrame(function () {
                panel.style.maxHeight = target + 'px';
              });
            });

            panel.addEventListener(
              'transitionend',
              function onOpenEnd(ev) {
                if (ev.propertyName !== 'max-height') return;
                if (details.open) setOpenFull();
              },
              { once: true }
            );
          } else {
            const h = inner.scrollHeight;
            panel.style.maxHeight = h + 'px';
            void panel.offsetHeight;
            requestAnimationFrame(function () {
              panel.style.maxHeight = '0px';
            });

            panel.addEventListener(
              'transitionend',
              function onCloseEnd(ev) {
                if (ev.propertyName !== 'max-height') return;
                details.open = false;
                panel.style.maxHeight = '0px';
              },
              { once: true }
            );
          }
        });
      });
    }

    function scan(doc) {
      doc.querySelectorAll(ROOT_SEL).forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scan(document);
      });
    } else {
      scan(document);
    }

    document.addEventListener('shopify:section:load', function (ev) {
      if (ev.target && ev.target.querySelector) {
        scan(ev.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-recipe-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ACC_HEADING_ALLOWED = { h2: true, h3: true, h4: true };

    function bindPrintButtons() {
      document.querySelectorAll('[data-pb-recipe-print]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          window.print();
        });
      });
    }

    function openAllSections(root) {
      root.querySelectorAll('details.pb-recipe-article__section').forEach(function (d) {
        d.setAttribute('open', '');
      });
    }

    function closeAllSections(root) {
      root.querySelectorAll('details.pb-recipe-article__section').forEach(function (d) {
        d.removeAttribute('open');
      });
    }

    function enhanceArticleAccordions(root) {
      if (!root || root.getAttribute('data-pb-rte-accordions-done') === '1') return false;

      var raw = root.getAttribute('data-pb-acc-heading') || 'h2';
      var headingSel = ACC_HEADING_ALLOWED[raw] ? raw : 'h2';
      var mode = root.getAttribute('data-pb-acc-open-mode') || 'first';

      var els = Array.prototype.slice.call(root.children);
      var sections = [];
      var lead = [];
      var i = 0;

      while (i < els.length && !els[i].matches(headingSel)) {
        lead.push(els[i]);
        i++;
      }

      while (i < els.length) {
        var h = els[i];
        if (!h.matches(headingSel)) {
          if (sections.length) {
            sections[sections.length - 1].body.push(h);
          } else {
            lead.push(h);
          }
          i++;
          continue;
        }
        i++;
        var body = [];
        while (i < els.length && !els[i].matches(headingSel)) {
          body.push(els[i]);
          i++;
        }
        sections.push({ heading: h, body: body });
      }

      if (sections.length === 0) return false;

      while (root.firstChild) {
        root.removeChild(root.firstChild);
      }

      if (lead.length) {
        var leadWrap = document.createElement('div');
        leadWrap.className = 'pb-recipe-article__lead';
        lead.forEach(function (n) {
          leadWrap.appendChild(n);
        });
        root.appendChild(leadWrap);
      }

      sections.forEach(function (sec, idx) {
        var det = document.createElement('details');
        det.className = 'pb-recipe-article__section';

        if (mode === 'all_open') {
          det.setAttribute('open', '');
        } else if (mode === 'first' && idx === 0) {
          det.setAttribute('open', '');
        }

        var sum = document.createElement('summary');
        sum.appendChild(sec.heading);

        var chev = document.createElement('span');
        chev.className = 'pb-recipe-article__section-chevron';
        chev.setAttribute('aria-hidden', 'true');
        sum.appendChild(chev);

        var bodyWrap = document.createElement('div');
        bodyWrap.className = 'pb-recipe-article__section-body';
        sec.body.forEach(function (n) {
          bodyWrap.appendChild(n);
        });

        det.appendChild(sum);
        det.appendChild(bodyWrap);
        root.appendChild(det);
      });

      root.setAttribute('data-pb-rte-accordions-done', '1');
      root.classList.add('pb-recipe-article__content--accordion');
      return true;
    }

    function wireToolbar(mainEl, bodyRoot) {
      var bar = mainEl.querySelector('.pb-recipe-article__accordion-toolbar');
      if (!bar) return;

      var expandAll = bar.querySelector('[data-pb-acc-expand-all]');
      var collapseAll = bar.querySelector('[data-pb-acc-collapse-all]');

      if (expandAll) {
        expandAll.addEventListener('click', function () {
          openAllSections(bodyRoot);
        });
      }
      if (collapseAll) {
        collapseAll.addEventListener('click', function () {
          closeAllSections(bodyRoot);
        });
      }
      bar.removeAttribute('hidden');
    }

    function initRecipeArticleUi() {
      bindPrintButtons();

      document.querySelectorAll('[data-pb-accordions]').forEach(function (bodyRoot) {
        var ok = enhanceArticleAccordions(bodyRoot);
        if (!ok) return;
        var main = bodyRoot.closest('.pb-recipe-article__main');
        if (main) wireToolbar(main, bodyRoot);
      });

      window.addEventListener('beforeprint', function () {
        document.querySelectorAll('.pb-recipe-article__content--accordion').forEach(openAllSections);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRecipeArticleUi);
    } else {
      initRecipeArticleUi();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
